// import { parseDateString, parseFmtDate } from "@saleor/utils/date";
import { useFormik } from "formik";
import { useIntl } from "react-intl";
import * as Yup from "yup";

const getSchema = () => {
  const intl = useIntl();
  const textError = intl.formatMessage({ defaultMessage: "โปรดระบุข้อมูล" });
  const textErrorQuantity = intl.formatMessage({
    defaultMessage: "โปรดระบุจำนวนที่ต้องการ"
  });

  // const textDateError = intl.formatMessage({
  //   defaultMessage:
  //     "กรุณาเปลี่ยน “Request Date” (ไม่สามารถใส่วันที่ปัจจุบัน หรือวันที่ผ่านมาแล้วได้)"
  // });

  return Yup.object().shape({
    quantity: Yup.array().of(Yup.string().required(textErrorQuantity)),
    rollQuantity: Yup.array().of(
      Yup.string().when(["isK01K09, isContainer"], {
        is: false,
        then: Yup.string().required(textError)
      })
    ),
    palletSize: Yup.array().of(
      Yup.string().when(["isK01K09, isContainer"], {
        is: false,
        then: Yup.string().required(textError)
      })
    ),
    rollPerPallet: Yup.array().of(
      Yup.string().when(["isK01K09, isContainer"], {
        is: false,
        then: Yup.string().required(textError)
      })
    ),
    palletNo: Yup.array().of(
      Yup.string().when(["isK01K09, isContainer"], {
        is: false,
        then: Yup.string().required(textError)
      })
    ),
    packageQuantity: Yup.array().of(
      Yup.string().when(["isK01K09, isContainer"], {
        is: false,
        then: Yup.string().required(textError)
      })
    ),
    packingList: Yup.array().of(
      Yup.string().when(["isK01K09, isContainer"], {
        is: false,
        then: Yup.string().required(textError)
      })
    )
    // requestDate: Yup.date().required(textError)
    // .when("isRequestDateChange", {
    //   is: true,
    //   then: Yup.date()
    //     .typeError(textError)
    //     .min(new Date(), textDateError)
    //     .required(textError)
    // }),
  });
};

export const getFormik = (
  listMaterial: any[],
  submitForm?: (value) => void
) => {
  const listLine = [...listMaterial];
  const formik = useFormik({
    validateOnChange: true,
    initialValues: {
      quantity: listLine.map(line => line.quantity),
      requestDate: listLine.map(line => line.requestDate),
      plant: listLine.map(line => line.plant),
      rollDiameter: listLine.map(line => line.rollDiameter?.toString()),
      rollCoreDiameter: listLine.map(line => line.rollCoreDiameter?.toString()),
      rollQuantity: listLine.map(line => line.rollQuantity?.toString()),
      palletSize: listLine.map(line => line.palletSize?.toString()),
      rollPerPallet: listLine.map(line => line.rollPerPallet?.toString()),
      palletNo: listLine.map(line => line.palletNo?.toString()),
      packageQuantity: listLine.map(line => line.packageQuantity?.toString()),
      shippingPoint: listLine.map(line => line.shippingPoint?.toString()),
      packingList: listLine.map(line => line.packingList?.toString()),
      deliveryTolUnder: listLine.map(line => line.deliveryTolUnder?.toString()),
      deliveryTolOver: listLine.map(line => line.deliveryTolOver?.toString()),
      route: listLine.map(line => line.route),
      deliveryTolUnlimited: listLine.map(line => line.deliveryTolUnlimited)
    },
    onSubmit: () => {
      submitForm(formik.values);
    },
    validationSchema: getSchema()
  });
  return formik;
};
